<div class="collapsible-container">
    <div class="collapsible-item" (click)="onToggleSection()">
        <div class="col-11 col-form-label pt-0 d-flex gap-1 align-items-center pb-0">
            {{ title }}
            @if(selectedCount != 0){
            <span class="badge bg-secondary-subtle text-secondary">
                {{ selectedCount }}
            </span>
            }
        </div>

        <i [hidden]="isDatePicker" [ngClass]="{ 'arrow-down': isOpen, 'arrow-right': !isOpen }"
            class="ri-arrow-right-s-line"></i>
    </div>
    @if(isOpen || isDatePicker){
    <div class="row collapsible-content">
        @if(conditionOperators.length > 0 && (isOpen || isDatePicker)){
        <div class="col-5 pe-0">
            <ng-select id="collapsible-filter-{{ filterKey }}" class="col-12 p-0 pe-1" appearance="outline"
                [searchable]="true" placeholder="{{ placeholder }}" [clearable]="false" [(ngModel)]="selectedOperator"
                (change)="emitData()">
                <ng-option *ngFor="let _data of conditionOperators; let i = index" [value]="_data.key">
                    {{ _data.value | translate }}
                </ng-option>
            </ng-select>
        </div>
        } @if (isDropdown) { @if (isMultiple) {
        <div class="row mb-3 d-flex gap-1 align-items-center">
            @if(metaData.isTypeList){
            <div class="col-12 pe-0 gap-1">
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="{{ metaData.placeholder | translate }}"
                            [(ngModel)]="searchText" (keyup.enter)="getUserList()"
                            [ngModelOptions]="{ standalone: true }" />
                        <button class="btn btn-outline-info material-shadow-none" type="button" id="search"
                            (click)="getUserList()">
                            {{ "label-title.search" | translate | titlecase }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-12 pe-0 d-flex gap-1 align-items-center">
                <ng-select id="collapsible-filter-{{ filterKey }}" [multiple]="true" [closeOnSelect]="false"
                    [searchable]="true" placeholder="{{ placeholder }}" class="col-12 p-0" [items]="typeData"
                    bindLabel="value" bindValue="key" [(ngModel)]="selectedValue" (close)="emitData()"
                    (clear)="emitData()">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{ index }}" class="form-check-input" type="checkbox" [ngModel]="item$.selected"
                            [ngModelOptions]="{ standalone: true }" />
                        <span style="margin-left: 5px">
                            @if (isMultiLanguageValue) {
                            {{ item.value | translatedName : helper.cuurentLang }}
                            } @else {
                            {{ item.value | translate }}
                            }</span>
                    </ng-template>

                    <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items.slice(0, 3)">
                            @if (isMultiLanguageValue) {
                            {{ item.value | translatedName : helper.cuurentLang }}
                            } @else {
                            {{ item.value | translate }}
                            }
                        </div>
                        <div class="ng-value" *ngIf="items.length > 3">
                            <span class="ng-value-label">{{ items.length - 3 }} {{ "label-title.more" | translate
                                }}...</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            } @else {
            <!-- @if(data.length > 0){ -->
            <div class="col-12 pe-0 d-flex gap-1 align-items-center">
                <ng-select id="collapsible-filter-{{ filterKey }}" [multiple]="true" [closeOnSelect]="false"
                    [searchable]="true" placeholder="{{ placeholder }}" class="col-12 p-0" [items]="data"
                    bindLabel="value" bindValue="key" [(ngModel)]="selectedValue" (close)="emitData()"
                    (clear)="emitData()">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{ index }}" class="form-check-input" type="checkbox" [ngModel]="item$.selected"
                            [ngModelOptions]="{ standalone: true }" />
                        <span style="margin-left: 5px">
                            @if (isMultiLanguageValue) {
                            {{ item.value | translatedName : helper.cuurentLang }}
                            } @else {
                            {{ item.value | translate }}
                            }</span>
                    </ng-template>

                    <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items.slice(0, 3)">
                            @if (isMultiLanguageValue) {
                            {{ item.value | translatedName : helper.cuurentLang }}
                            } @else {
                            {{ item.value | translate }}
                            }
                        </div>
                        <div class="ng-value" *ngIf="items.length > 3">
                            <span class="ng-value-label">{{ items.length - 3 }} {{ "label-title.more" | translate
                                }}...</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            }
            <!-- } -->
        </div>
        }@else{
        <div [class]="conditionOperators.length > 0 ? 'col-7' : 'col-12'" class="mb-3 d-flex gap-1 align-items-center">
            <ng-select id="collapsible-filter-{{ filterKey }}" class="col-12 p-0 pe-1" appearance="outline"
                [searchable]="true" placeholder="{{ placeholder }}" [clearable]="false" [(ngModel)]="selectedValue"
                (change)="emitData()">
                <ng-option *ngFor="let _data of data; let i = index" [value]="_data.key">
                    @if (isMultiLanguageValue) {
                    {{ _data.value | translatedName : helper.cuurentLang }}
                    } @else {
                    {{ _data.value | translate }}
                    }
                </ng-option>
            </ng-select>
        </div>
        } }@else if(isDatePicker){

        <div [class]="conditionOperators.length > 0 ? 'col-7' : 'col-12'" class="mb-3 d-flex gap-1 align-items-center">
            <input class="form-control c-pointer unset-readonly" type="text" [(ngModel)]="selectedValue"
                (click)="openDatePicker()" readonly placeholder="{{ datePlaceholder | translate }}" />
        </div>
        @if(showDatePicker){
        <app-date-picker (dateRangeChange)="onDateRangeChange($event)" [activeTab]="activeTab" [filterDate]="filterDate"
            [isScheduleDate]="isScheduleDate"></app-date-picker>
        } } @if(isInput){
        <div [class]="conditionOperators.length > 0 ? 'col-7' : 'col-12'" class="mb-3 d-flex gap-1 align-items-center">
            <input class="form-control" type="text" [(ngModel)]="selectedValue"
                (keypress)="helper.numberValidation($event)" (keyup.enter)="emitData()" (blur)="emitData()"
                placeholder="{{ placeholder }}" />
        </div>
        }
    </div>
    }
</div>